import header from './imports/header';
import scrollToTop from './imports/scroll-to-top';
import cookies from './imports/cookies';
// import cart from './imports/cart';


document.addEventListener('DOMContentLoaded', () => {
  header();
  scrollToTop();
  cookies();
  // cart();
});
